import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {GetTenantCompanyClient, UpdateTenantCompanyClient} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

// API Clients
const getTenantCompanyClient = new GetTenantCompanyClient(SERVICE_URL)
const updateTenantCompanyClient = new UpdateTenantCompanyClient(SERVICE_URL)

const initialState = {
  loading: false,
  isRedirect: false,
  error: null,
  isDeleted: false,
  isArchived: false,
  detail: null,
}

// Async Thunks
export const tenantcompanyGet = createAsyncThunk('tenantcompany/get', async (_, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getTenantCompanyClient.get()
    dispatch(setDetail(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const tenantcompanyUpdate = createAsyncThunk(
  'tenantcompany/update',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await updateTenantCompanyClient.update(
        params.Name,
        params.Title,
        params.Address,
        params.ProvinceId,
        params.DistrictId,
        params.Phone,
        params.Fax,
        params.TaxOffice,
        params.TaxNumber,
        params.RegisterNumber,
        params.Email,
        params.LogoFile,
        params.Iban,
        params.MersisNo,
        params.PostalCode,
        params.TicariSicilNo,
        params.WebSite,
        params.SealSignatureFile
      )
      dispatch(setRedirect(response || params))
      dispatch(setDetail(params))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setDetail(params))
      dispatch(setError(error))
      throw error
    }
  }
)

// Slice
const tenantcompanySlice = createSlice({
  name: 'tenantcompany',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    setDeleted: (state, action) => {
      state.isDeleted = action.payload
      state.loading = false
    },
    setRedirect: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setArchived: (state, action) => {
      state.isArchived = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('tenantcompany/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  }
})

// Export actions
export const {setLoading, setError, setDetail, setDeleted, setRedirect, setArchived, resetState} =
  tenantcompanySlice.actions

// Selectors
export const selectTenantCompanyLoading = (state) => state.tenantcompany.loading
export const selectTenantCompanyError = (state) => state.tenantcompany.error
export const selectTenantCompanyDetail = (state) => state.tenantcompany.detail
export const selectTenantCompanyDeleted = (state) => state.tenantcompany.isDeleted
export const selectTenantCompanyRedirect = (state) => state.tenantcompany.isRedirect
export const selectTenantCompanyArchived = (state) => state.tenantcompany.isArchived

export default tenantcompanySlice.reducer
